import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  description: yup
    .string()
    .required()
    .trim()
});

export default schema;
